import { ReactNode } from 'react'
import { Box } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'

import { FormattedMessage } from 'react-intl'
import { RoundedIconSize, RoundedIconProps } from '../RoundedIcon'

export interface ShareOptionLabelProps {
  size?: RoundedIconSize
  title: string | ReactNode
  isDefault?: boolean
  description: string | ReactNode
  iconComponent?: React.ComponentType<Omit<RoundedIconProps, 'icon'>>
  selected?: boolean
}

function ShareOptionLabel({
  title,
  isDefault,
  description,
  iconComponent: IconComponent,
  selected,
  size = 'medium'
}: ShareOptionLabelProps) {
  const isSmall = size === 'small'

  return (
    <Box display="flex" alignItems="center" flex={1}>
      {IconComponent && <IconComponent state={selected ? 'selected' : ''} size={size} />}
      <Box ml={1.5}>
        <Box display="flex" alignItems="flex-end" gap={1}>
          <Typography
            aria-label="create-application-share-label"
            color="textPrimary"
            variant={isSmall ? 'body2' : 'body1'}
          >
            {title}
          </Typography>
          {!!isDefault && (
            <Box>
              <Typography color="textSecondary" variant="caption">
                <FormattedMessage id="common.shareDialog.default" />
              </Typography>
            </Box>
          )}
        </Box>
        <Typography color="textSecondary" variant="body2" component="div">
          {description}
        </Typography>
      </Box>
    </Box>
  )
}

export default ShareOptionLabel
